import JulaLogo from 'components/JulaLogo';
import Link from 'components/Link';
import RichText from 'components/RichText';
import type { HTMLString } from 'types';
import { useI18n } from 'utils/i18n';

import TryggEhandel from './TryggEhandel';

interface Props {
	className?: string;
	text?: HTMLString;
}

/** Site logo and a short info text. */
export default function PageFooterInfo({ className, text }: Props) {
	const { t } = useI18n();

	return (
		<div className={className}>
			<Link
				href="/"
				aria-label={t('general_jula_logo_start_page_link_label')}
				// Pointless but pretty — match focus outline with logo radius.
				className="inline-block shrink-0 rounded-[10px] focus-visible:focus-outline-inverted"
			>
				<JulaLogo />
			</Link>
			{text && <RichText html={text} className="mt-3" inheritStyle />}

			<TryggEhandel className="not-empty:mt-6" />
		</div>
	);
}
PageFooterInfo.displayName = 'PageFooterInfo';
